export default __webpack_public_path__ + "static/media/pantry1-afterB-1920w.bf32f4b2.png";